import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import addAction from './add-action.vue';
import variable from './variable.scss';
import { showData } from '../util';
/**
 *  @override 根据节点类型获取title对应的颜色
 *  sourceData.type 0发起人 1审批人 2抄送节点 3条件分支   9结束
 *  @example colorMap.get(4) // variable color #112233
 */
var launch = variable.launch,
  Approval = variable.Approval,
  CC = variable.CC;
var colorMap = new Map([[0, launch], [1, Approval], [2, CC], [9, launch]]);
export default {
  name: 'Approval',
  components: {
    addAction: addAction
  },
  props: {
    // 当前节点数据源
    sourceData: {
      type: Object,
      default: function _default() {}
    },
    // 删除当前节点
    del: {
      type: Function,
      default: function _default() {
        return function () {};
      }
    },
    // 选中节点UID
    selectedId: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      name: '',
      // 节点名称
      isEdit: false,
      colorMap: colorMap // 色值映射
    };
  },

  computed: {
    warnStatus: function warnStatus() {
      return this.sourceData.warning && this.sourceData.warning.status && this.sourceData.warning.msg;
    },
    warnMsg: function warnMsg() {
      return this.sourceData.warning && this.sourceData.warning.msg || '';
    },
    isShow: function isShow() {
      return ![0, 9].includes(this.sourceData.type);
    },
    label: function label(vm) {
      return showData(vm.sourceData);
    },
    placeholder: function placeholder(vm) {
      var type = vm.sourceData.type;
      if (type === 0) return vm.$t('162');
      if (type === 9) return vm.$t('165');
      return vm.$t('164');
    }
  },
  // 点击选中 节点添加
  inject: ['handlerSelected', 'handlerAddNode'],
  methods: {
    /**
     *  @description 节点内容展示
     *  @returns { String }
     */
    handlerNodeContent: function handlerNodeContent() {
      return showData(this.sourceData);
    },
    // 修改名称input展示
    handlerEdit: function handlerEdit() {
      var _this = this;
      if (!this.isShow) return false;
      this.isEdit = true;
      this.name = this.sourceData.nodeName;
      this.$refs.inputs.focus();
      this.$nextTick(function () {
        _this.$refs.inputs.select();
        _this.$refs.inputs.focus();
      });
    },
    // 存储名称
    handlerSave: function handlerSave() {
      this.isEdit = false;
      this.sourceData.nodeName = this.name;
    }
  }
};